import Navbar from './Navbar';

export default function About() {
    return(
        <>


        <center><h1>About</h1></center>

        <Navbar />
        
        
        
        </>
    )
}